import { Duck } from './Duck';
import type { MascotName } from '../theme/ThemeProvider';

type Props = {
  mascot: MascotName;
};

const NAV_LINKS: { href: string; label: string }[] = [
  { href: '#top', label: 'Home' },
  { href: '#panelists', label: 'Panelists' },
  { href: '#roadmap', label: 'Roadmap' },
];

export function Header({ mascot }: Props): JSX.Element {
  return (
    <header
      id="top"
      className="sticky top-0 z-50 flex items-center justify-between border-b-2 border-ink bg-bg px-8 py-3"
    >
      <a href="#top" className="flex shrink min-w-0 items-center gap-3 no-underline">
        <Duck variant={mascot} size={44} />
        <div className="text-left min-w-0">
          <div className="font-display text-lg font-extrabold leading-tight tracking-[-0.02em] text-ink whitespace-nowrap">
            The Rubber Duck Debate
          </div>
          <div className="mt-1 font-mono text-[9.5px] tracking-[0.08em] text-ink-soft whitespace-nowrap">
            QUACK · ARGUE · COMPILE
          </div>
        </div>
      </a>
      <nav className="flex items-center gap-2">
        {NAV_LINKS.map((l) => (
          <a
            key={l.href}
            href={l.href}
            className="rounded-full px-3.5 py-2.5 font-display text-sm font-semibold text-ink-soft no-underline hover:text-ink"
          >
            {l.label}
          </a>
        ))}
        <a
          href="#register"
          className="ml-2 rounded-full bg-ink px-[18px] py-2.5 font-display text-sm font-bold text-bg no-underline"
        >
          Reserve seat →
        </a>
      </nav>
    </header>
  );
}
